export enum RatingScaleType {
  PRICING = 'PRICING',
  WAITING_TIME = 'WAITING_TIME',
  FRIENDLY_STAFF = 'FRIENDLY_STAFF',
  UPSELLING = 'UPSELLING',
}
